/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

export enum CREATE {
	OPEN = "readmeEditor.create.open"
}

export enum EDIT {
	UNDO = "readmeEditor.edit.undo",
	REDO = "readmeEditor.edit.redo",
	SAVE = "readmeEditor.edit.save"
}
